import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { TokeetAIChargeResponse } from './ai-charge.model'

export interface State extends EntityState<TokeetAIChargeResponse> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<TokeetAIChargeResponse> = createEntityAdapter<TokeetAIChargeResponse>({
  sortComparer: false,
  selectId: (t) => t.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
